import Layout from '@/components/layout';

/* 引入各个模块的路由 */
import home from './modules/home';
import school from './modules/school';
import consumption from './modules/consumption';
import settings from './modules/settings';
import usage from './modules/usage';
import settingManagement from './modules/setting-management';
import product from './modules/product';
import safetyManagement from './modules/safety-management';
import accessManagement from './modules/access-management';
import oem from './modules/oem';
import applicationManagement from './modules/application-management';
import healthManagement from './modules/health-management';
import CustomTag from './modules/custom-tag';
import finacialManagement from './modules/finacial-management';
import schoolInformation from './modules/school-information';
import schoolAffair from './modules/school-affair';
import schoolSafety from './modules/school-safety';
import schoolFinance from './modules/school-finance';
import schoolBusiness from './modules/school-business';
import schoolSetup from './modules/school-setup';
import zhaonaxSchoolManagement from './modules/zhaonax-school-management';
import schoolWorkManagement from './modules/school-work-management';
import subjectNetwork from './modules/subject-network';
import dailyEvaluation from './modules/daily-evaluation';
import recipesManage from './modules/recipes-management';

/**
 * 菜单路由
 */
export const menuRoutesMap = [
	{
		...zhaonaxSchoolManagement,
		component: Layout
	},
	{
		...schoolInformation,
		component: Layout
	},
	{
		...schoolAffair,
		component: Layout
	},
	{
		...schoolSafety,
		component: Layout
	},
	{
		...schoolFinance,
		component: Layout
	},
	{
		...schoolSetup,
		component: Layout
	},
	{
		...schoolBusiness,
		component: Layout
	},
	{
		...home,
		component: Layout
	},
	{
		...school,
		component: Layout
	},
	{
		...consumption,
		component: Layout
	},
	{
		...settingManagement,
		component: Layout
	},
	{
		...product,
		component: Layout
	},
	{
		...safetyManagement,
		component: Layout
	},
	{
		...accessManagement,
		component: Layout
	},
	{
		...oem,
		component: Layout
	},
	{
		...applicationManagement,
		component: Layout
	},
	{
		...healthManagement,
		component: Layout
	},
	{
		...finacialManagement,
		component: Layout
	},
	{
		...CustomTag,
		component: Layout
	},
	{
		...schoolWorkManagement,
		component: Layout
	},
	{
		...subjectNetwork,
		component: Layout
	},
	{
		...dailyEvaluation,
		component: Layout
	},
	{
		...recipesManage,
		component: Layout
	}
];
/**
 * 静态路由
 */
const constantRoutesMap = [
	{
		path: '/authorize',
		name: 'authorize',
		meta: {
			title: '授权',
			hideInMenu: true
		},
		component: () =>
			import(/* webpackChunkName: "authorize" */ '@/views/authorize')
	},
	{
		name: 'buffer',
		path: '/buffer',
		meta: {
			title: '旧版退出缓存'
		},
		component: () =>
			import(/* webpackChunkName: "buffer" */ '@/views/logout/buffer')
	},
	{
		name: 'logout',
		path: '/logout',
		meta: {
			title: '旧版退出'
		},
		component: () => import(/* webpackChunkName: "logout" */ '@/views/logout')
	},
	{
		name: 'login',
		path: '/login',
		meta: {
			title: '登录',
			hideInMenu: true
		},
		component: () => import(/* webpackChunkName: "login" */ '@/views/login')
	},
	{
		name: 'error-401',
		path: '/401',
		meta: {
			title: 'Not Auth',
			icon: 'icon-doc'
		},
		component: () =>
			import(/* webpackChunkName: "401" */ '@/views/error-page/401')
	},
	{
		name: 'error-500',
		path: '/500',
		meta: {
			title: 'Server Error',
			icon: 'icon-doc'
		},
		component: () =>
			import(/* webpackChunkName: "500" */ '@/views/error-page/500')
	},
	{
		name: 'error-404',
		path: '/404',
		meta: {
			title: 'Not Find',
			icon: 'icon-doc'
		},
		component: () =>
			import(/* webpackChunkName: "500" */ '@/views/error-page/404')
	},
	{
		name: 'not-find',
		path: '*',
		redirect: '/404'
	}
];

// console.log('fuck', menuRoutesMap);
export const routes = [
	...constantRoutesMap,
	...menuRoutesMap,
	{
		...usage,
		component: Layout
	},
	{
		...settings,
		component: Layout
	}
];
